export const cards = new Array(6).fill('card');
